import { Box, Drawer, Stack, Typography, IconButton, Divider, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import CloseRounded from '@mui/icons-material/CloseRounded';
import LogoutRounded from '@mui/icons-material/LogoutRounded';
import { PRIMARY_NAV } from '../../config/navConfig';
import logo from '../../assets/logo.png';

type Props = {
  open: boolean;
  onClose: () => void;
  active: string;
  go: (path: string) => void;
  onLogout: () => void;
};

const MobileNavDrawer = ({ open, onClose, active, go, onLogout }: Props) => {
  const handleGo = (path: string) => {
    go(path);
    onClose();
  };

  return (
    <Drawer anchor="left" open={open} onClose={onClose} sx={{ display: { xs: 'block', md: 'none' } }}>
      <Box sx={{ width: 280, display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2, py: 1 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box component="img" src={logo} alt="QuillStack" sx={{ width: 28, height: 28, borderRadius: 1 }} />
            <Typography fontWeight={800}>QuillStack</Typography>
          </Stack>
          <IconButton onClick={onClose} aria-label="Close menu">
            <CloseRounded />
          </IconButton>
        </Stack>

        <Divider />

        <List sx={{ flex: 1, overflowY: 'auto' }}>
          {PRIMARY_NAV.map(({ label, path, icon: Icon, matchPrefix }) => (
            <ListItemButton key={path} selected={active.startsWith(matchPrefix)} onClick={() => handleGo(path)}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <Icon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={label} />
            </ListItemButton>
          ))}
        </List>

        <Divider />
        <ListItemButton onClick={onLogout}>
          <ListItemIcon sx={{ minWidth: 36 }}>
            <LogoutRounded fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItemButton>
      </Box>
    </Drawer>
  );
};

export default MobileNavDrawer;
